__turbopack_context__.v({
  "figure": "Cc8UIW_figure",
  "imageWrapper": "Cc8UIW_imageWrapper",
  "imgCaption": "Cc8UIW_imgCaption",
});
